// TargetGroup maps to top level categories, e.g. male, female and kids category.
export enum TargetGroup {
  TARGET_GROUP_UNSPECIFIED = 0,
  TARGET_GROUP_FEMALE = 1,
  TARGET_GROUP_MALE = 2,
  TARGET_GROUP_KIDS = 3,
}
